import { Button, styled } from '@mui/material';

export const LocationGroupShowButton = styled(Button)`
  margin: 5px;
  padding: 8px 10px 10px 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
`;
